
export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const getPercentage = (amount: number, total: number) => {
  if (total <= 0) return '0';
  const percentage = (amount / total) * 100;
  return Math.min(percentage, 100).toFixed(1); // Cap at 100%
};

export const getCategoryColor = (category: string) => {
  switch(category.toLowerCase()) {
    case 'directors': return 'from-purple-600 to-pink-600';
    case 'managers': return 'from-blue-600 to-cyan-600';
    case 'team leads': return 'from-green-600 to-emerald-600';
    case 'team members': return 'from-orange-600 to-red-600';
    default: return 'from-gray-600 to-gray-500';
  }
};

export const getCategoryIcon = (category: string) => {
  switch(category.toLowerCase()) {
    case 'directors': return '👑';
    case 'managers': return '🎯';
    case 'team leads': return '⚡';
    case 'team members': return '👥';
    default: return '💼';
  }
};
